<template>
  <shark-loader v-if="pendingTeamLoading" />
  <router-view v-else />
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'SignupPayBase',
	computed: {
		...mapState(["pendingTeamLoading"])
	},
	created() {
    let seasonId = this.$route.params.seasonId;
    let leagueId = this.$route.params.leagueId;
    let pendingTeamId = this.$route.params.pendingTeamId;
		this.$store.dispatch("loadPendingTeamData", { seasonId, leagueId, pendingTeamId });
	},
}
</script>
